import { useContext } from 'react'
import { OrganizationContext } from '../contexts/Organization'

const useOrganization = () => {
   const data = useContext(OrganizationContext)
   return data
}

export default useOrganization
